'use client';

import { TextInput } from '@mantine/core';
import React from 'react';
import { Button } from '../../ui/Button';

interface InputMultipleBreakoutProps {
  defaultValue: (string | undefined)[][];
  onChange: (items: (string | undefined)[][]) => void;
  placeholders: Array<string> | undefined;
  className?: string;
  disabled?: boolean;
}

function InputMultipleBreakout({
  defaultValue,
  onChange,
  className,
  placeholders,
  disabled,
  ...props
}: InputMultipleBreakoutProps) {
  const [items, setItems] =
    React.useState<(string | undefined)[][]>(defaultValue);

  return (
    <div className="col-span-12">
      {items != undefined &&
        items.map((item, index) => (
          <div className="w-full mb-2" key={index}>
            <div className="inline-flex flex-col items-center justify-center gap-2.5 px-[12.5px] py-2.5 relative rounded-[100px] border border-solid border-[#377d91]">
              <div className="relative w-[15px] mt-[-1.00px] font-text-sm-regular font-[number:var(--text-sm-regular-font-weight)] text-[#101828] text-[length:var(--text-sm-regular-font-size)] text-center tracking-[var(--text-sm-regular-letter-spacing)] leading-[var(--text-sm-regular-line-height)] [font-style:var(--text-sm-regular-font-style)]">
                {index + 1}
              </div>
            </div>
            {placeholders != undefined &&
              placeholders.map((placeholder, indexer) => (
                <TextInput
                  className="mt-3"
                  classNames={{ input: 'w-full' }}
                  key={indexer}
                  placeholder={placeholder}
                  disabled={disabled}
                  onBlur={(event) => {
                    if (
                      event != undefined &&
                      items.length > index &&
                      items[index] != undefined
                    ) {
                      items[index][indexer] = event.target.value;
                      setItems(items);
                      onChange(items);
                    }
                  }}
                  defaultValue={item[indexer]}
                />
              ))}
            {index == items.length - 1 && !disabled && (
              <div className="col-span-2 ml-2">
                <div className="mt-4 mb-4">
                  <Button
                    text={'- Remove'}
                    onClick={() => {
                      if (items.length > 1) {
                        setItems(items.slice(0, items.length - 1));
                        onChange(items);
                      }
                    }}
                    variant={'secondary'}
                  ></Button>{' '}
                </div>
                <Button
                  text={'+ Add'}
                  onClick={() => {
                    setItems([...items, [undefined, undefined, undefined]]);
                    onChange(items);
                  }}
                  variant={'secondary'}
                ></Button>
              </div>
            )}
          </div>
        ))}
    </div>
  );
}

export { InputMultipleBreakout };
